import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const CalendarBookedIcon = React.memo(
  ({ width = 24, fill = variables['colors-mc-primary'], viewBox = '0 0 24 24' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <path
        id='Path_12341'
        data-name='Path 12341'
        d='M13.531,7.219a.75.75,0,0,1,0,1.062l-4.5,4.5a.75.75,0,0,1-1.062,0l-2.25-2.25A.751.751,0,0,1,6.781,9.469L8.5,11.19l3.969-3.971a.75.75,0,0,1,1.062,0Z'
        transform='translate(2.75 3.5)'
        fill={fill}
      />
      <path
        id='Path_12342'
        data-name='Path 12342'
        d='M5.25,0A.75.75,0,0,1,6,.75V1.5H18V.75a.75.75,0,0,1,1.5,0V1.5H21a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V4.5a3,3,0,0,1,3-3H4.5V.75A.75.75,0,0,1,5.25,0ZM1.5,6V21A1.5,1.5,0,0,0,3,22.5H21A1.5,1.5,0,0,0,22.5,21V6Z'
        fill={fill}
      />
    </svg>
  )
);
CalendarBookedIcon.displayName = 'CalendarBookedIcon';

export default CalendarBookedIcon;
